import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function CampaignsIcon({ className }: IconProps) {
  return (
    <svg
      width="75"
      height="56"
      viewBox="0 0 75 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_1027)">
        <path
          d="M21.9941 40.21C23.686 40.21 25.0567 41.5737 25.0567 43.2571V44.7914C25.0567 46.4748 23.686 47.8386 21.9941 47.8386V40.21Z"
          fill="#00416B"
        />
        <path
          d="M18.675 55.9998C16.8332 55.9998 15.3555 54.5082 15.3555 52.6969V36.1611H21.9945V52.6969C21.9945 54.5295 20.4954 55.9998 18.675 55.9998Z"
          fill="#EAEDF8"
        />
        <path
          d="M11.522 13.2327H20.474C21.3307 13.2327 22.016 13.9146 22.016 14.767V36.1399H11.522C5.16134 36.1399 0 31.0044 0 24.6757C0 18.3469 5.16134 13.2114 11.522 13.2114"
          fill="#00C4B3"
        />
        <path
          d="M12.0142 31.047C11.5858 31.047 11.2432 30.706 11.2432 30.2798V19.0713C11.2432 18.6451 11.5858 18.3042 12.0142 18.3042C12.4425 18.3042 12.7851 18.6451 12.7851 19.0713V30.2798C12.7851 30.706 12.4425 31.047 12.0142 31.047Z"
          fill="#00416B"
        />
        <path
          d="M16.8765 31.047C16.4481 31.047 16.1055 30.706 16.1055 30.2798V19.0713C16.1055 18.6451 16.4481 18.3042 16.8765 18.3042C17.3048 18.3042 17.6474 18.6451 17.6474 19.0713V30.2798C17.6474 30.706 17.3048 31.047 16.8765 31.047Z"
          fill="#00416B"
        />
        <path
          d="M7.15282 31.047C6.7245 31.047 6.38184 30.706 6.38184 30.2798V19.0713C6.38184 18.6451 6.7245 18.3042 7.15282 18.3042C7.58115 18.3042 7.92381 18.6451 7.92381 19.0713V30.2798C7.92381 30.706 7.58115 31.047 7.15282 31.047Z"
          fill="#00416B"
        />
        <path
          d="M72.8366 32.7094C74.8926 29.2999 75.5137 25.2938 74.5714 21.4156C73.629 17.4947 71.1876 14.1705 67.7396 12.061C64.2701 9.95137 60.201 9.29079 56.2604 10.2497C52.3198 11.1873 48.9789 13.5952 46.8372 17.0473C44.717 20.478 44.0745 24.548 45.0168 28.4689C45.9377 32.3045 48.2721 35.5648 51.5916 37.6744L51.8486 37.8235C55.3181 39.9331 59.3872 40.5724 63.3278 39.6348L64.0559 39.4643L63.285 36.268L62.5782 36.4384C59.4943 37.1842 56.3032 36.6728 53.5834 35.0107C50.8849 33.3486 48.9789 30.7489 48.2293 27.6804C47.4797 24.6119 47.9937 21.4369 49.6428 18.7307C51.2918 16.0457 53.926 14.1492 57.01 13.4247C60.0939 12.6789 63.285 13.1903 66.0048 14.8524C68.7033 16.5145 70.6093 19.1142 71.3589 22.1827C71.98 24.7185 71.7444 27.3182 70.695 29.6622L68.7033 28.4476L68.5748 28.3623C69.2815 26.5937 69.4314 24.6333 68.9603 22.7368C68.382 20.3075 66.8615 18.2406 64.7199 16.9194C62.5782 15.5982 60.0297 15.1934 57.5882 15.79C55.1468 16.3654 53.0694 17.8783 51.7416 20.0092C50.4352 22.1401 50.0282 24.6759 50.6065 27.1051C51.1847 29.4917 52.641 31.5161 54.7184 32.8372L54.8683 32.9224C57.01 34.2223 59.5585 34.6272 62 34.0518L62.7067 33.8814L61.9357 30.685L61.229 30.8555C59.6442 31.239 57.9951 30.9833 56.6031 30.131C55.211 29.2786 54.2259 27.9361 53.8404 26.3593C53.5834 25.3151 53.6262 24.271 53.9046 23.2695L57.524 25.4856L58.9374 26.338L64.163 29.5343L66.99 31.2603L71.8943 34.2436L72.8366 32.7307M60.6722 23.5678L59.2587 22.7154L55.6393 20.4993C56.4103 19.7961 57.3312 19.2847 58.3806 19.029C59.9654 18.6454 61.6145 18.9011 63.0065 19.7748C64.3986 20.6272 65.3838 21.9696 65.7693 23.5465C66.0262 24.5906 65.9834 25.6348 65.705 26.6363L60.6722 23.5678Z"
          fill="#00416B"
        />
        <path
          d="M47.587 2.55713L21.4805 13.7443V35.6287L47.587 46.8372V2.55713Z"
          fill="#EAEDF8"
        />
        <path
          d="M49.8784 49.3729C48.6148 49.3729 47.5654 48.3501 47.5654 47.0715V2.30137C47.5654 1.04414 48.5934 0 49.8784 0C51.1634 0 52.1699 1.02283 52.1699 2.30137V47.0928C52.1699 48.3714 51.142 49.3942 49.8784 49.3942"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_1027">
          <rect width="75" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
